/** An amount with its word, like "1 song" or "3 songs". Only for words that just get an s. */
export function count(amount: number, word: string): string {
    return `${amount} ${amount === 1 ? word : `${word}s`}`;
}
